import HeroSection from "../home/HeroSection";
import TrustStrip from "../home/TrustStrip";
import CategoryGrid from "../home/CategoryGrid";
import FeaturedProducts from "../home/FeaturedProducts";
import NewsletterSection from "../home/NewsletterSection";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <TrustStrip />
      <CategoryGrid />
      <FeaturedProducts />
      <NewsletterSection />
    </>
  );
}
